module.exports = "/_next/static/images/prapanch-efb88a6372d974dcd8037ee38be56a56.jpg";